import { render, staticRenderFns } from "./crearTipoAnuncio.vue?vue&type=template&id=1c472caf&scoped=true"
import script from "./crearTipoAnuncio.vue?vue&type=script&lang=js"
export * from "./crearTipoAnuncio.vue?vue&type=script&lang=js"
import style0 from "./crearTipoAnuncio.vue?vue&type=style&index=0&id=1c472caf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c472caf",
  null
  
)

export default component.exports